var WPloading = function (obj) {
    var self;

    let loading = function (el) {

        if (typeof el != 'object') {
            return false;
        }

        this.element = el.ele
        this.tag = this.element.querySelectorAll('[data-loading]');

        self = $.extend({}, this);
        window._loading = {};
        self.init();

        return self;
    }

    loading.prototype = {
        init() {

            for (let div of self.tag) {
                div.id = Is.uuid();
                window._loading[div.id] = false;
            }
        },
        end(ele) {
            if (!ele) {
                return;
            }

            let id = ele.attr('id');
          
            if (!window._loading[id]) {
               
                ele.animate({
                    opacity: 0
                }, 2000);

                setTimeout(function () {
                    ele.remove();
                }, 2100)
            }
        }
    };

    return new loading(obj);
};